// Night mode, per PERSON (owner 2026-10-03): the call that saves the signed-in
// person's choice on the server (worker PUT /users/me/theme → profiles.theme_pref,
// migration 209). The choice comes back with the profile (GET /auth/me).
//
// A file of its own (like lib/pushPrefsApi.ts) so lib/theme/adminTheme.ts stays
// free of the network and parallel work on lib/api.ts never collides.
import { apiFetch } from '@/lib/api';
import type { ThemePref } from './adminTheme';

/** true once the server stored it; false (never throws) when it could not —
 *  the store keeps the choice and sends it again on the next profile load. */
export async function saveThemePref(pref: ThemePref): Promise<boolean> {
  try {
    await apiFetch<{ ok: boolean; pref: ThemePref }>('/users/me/theme', {
      method: 'PUT',
      body: JSON.stringify({ pref }),
    });
    return true;
  } catch {
    return false;
  }
}
